import * as React from "react";

import styled from "@emotion/styled";
import CloseIcon from "../../svgs/close.svg";
import { breakpoints } from "../../styles/breakpoints";

const StyledAnnouncement = styled.div`
  position: relative;
  background: #ec8e87;
  padding: var(--micro) 0;
  text-align: center;
  font-size: var(--p-x-small);
  color: var(--white);
  transition: all 0.2s;
  font-weight: 700;

  @media (max-width: ${breakpoints.lg}) {
    height: var(--announcement-height-tablet);
  }

  @media (max-width: ${breakpoints.sm}) {
    height: var(--announcement-height-mobile);
  }

  @media (max-width: ${breakpoints.xs}) {
    padding: var(--micro) var(--small);
  }

  @media (max-width: 465px) {
    font-size: var(--p-xx-small);
    padding: var(--micro);
  }

  @media (max-width: 360px) {
    padding: var(--micro) var(--nano);
    font-size: 1.2rem;
  }

  @media (max-width: 320px) {
    text-align: left;
  }

  p {
    @media (min-width: calc(${breakpoints.sm} + 1px)) {
      span:not(.emoji) {
        display: none;
      }
    }
  }

  button {
    position: absolute;
    top: 50%;
    right: 2rem;
    transform: translateY(-50%);

    @media (max-width: 400px) {
      right: 1rem;
    }
  }

  img {
    height: 2.9rem;
  }
`;

export const Announcement = () => {
  const banner = React.useRef(null);

  const handleClick = () => {
    banner.current.style.display = "none";
    if (banner.current.style.display === "") {
      document.body.classList.add("banner-is-shown");
    } else {
      document.body.classList.remove("banner-is-shown");
    }
  };

  React.useEffect(() => {
    if (banner.current.style.display === "") {
      document.body.classList.add("banner-is-shown");
    }
  });

  return (
    <StyledAnnouncement ref={banner}>
      <p>
        🏆 We Made the Most Recent Inc.
        <span>
          <br />
          &nbsp;
        </span>{" "}
        5000, Best Workplaces, Power Partner, & Regionals Lists! 🏆
      </p>
      <button onClick={handleClick}>
        <img src={CloseIcon} alt="Close" />
      </button>
    </StyledAnnouncement>
  );
};
